import { createContext, useContext } from 'react'

export type DarkMode = 'light' | 'dark' | 'system'

export interface DarkModeContextType {
  mode: DarkMode
  isDark: boolean
  setMode: (mode: DarkMode) => void
  toggle: () => void
}

export const DarkModeContext = createContext<DarkModeContextType | undefined>(undefined)

export function useDarkMode(): DarkModeContextType {
  const ctx = useContext(DarkModeContext)
  if (!ctx) throw new Error('useDarkMode must be used inside DarkModeProvider')
  return ctx
}
